export const compareMatchEvents = (a, b) =>
	(a.fraction ?? 0) - (b.fraction ?? 0) ||
	(a.minute ?? 0) - (b.minute ?? 0) ||
	(a.recoveryMinutes ?? 0) - (b.recoveryMinutes ?? 0) ||
	(a.sequence ?? 0) - (b.sequence ?? 0) ||
	(a.creationDate ?? "").localeCompare(b.creationDate ?? "") ||
	(a.id ?? "").localeCompare(b.id ?? "");

export const matchEventTime = (event) =>
	`${event.minute ?? "?"}'${event.recoveryMinutes ? ` + ${event.recoveryMinutes}'` : ""} (${event.fraction ?? "?"}T)${event.timeConvention === "period" ? "" : " — minuto precedente da verificare"}`;

export const matchEventBelongsToSide = (event, match, side) =>
	event.matchSide
		? event.matchSide === side
		: match.homeClubId !== match.awayClubId &&
			event.clubId === (side === "home" ? match.homeClubId : match.awayClubId);

export const participationBeforeEvent = (
	players,
	events,
	side,
	position,
	excludedId,
) => {
	const onPitch = new Set(
		players.filter((p) => p.startingPlayer).map((p) => p.playerId),
	);
	const appeared = new Set(onPitch),
		dismissed = new Set(),
		injured = new Set(),
		injuryVacancies = new Set();
	[...events]
		.filter(
			(e) =>
				e.id !== excludedId &&
				e.matchSide === side &&
				compareMatchEvents(e, position) < 0,
		)
		.sort(compareMatchEvents)
		.forEach((e) => {
			if (e.eventType === "substitution") {
				const incoming = e.playerId ?? e.scorerParticipationId;
				const outgoing = e.substitutePlayerId ?? e.outgoingParticipationId;
				onPitch.delete(outgoing);
				onPitch.add(incoming);
				injured.delete(incoming);
				injuryVacancies.delete(incoming);
				injuryVacancies.delete(outgoing);
				appeared.add(incoming);
				appeared.add(outgoing);
				if (e.substitutionReason === "injury") injured.add(outgoing);
			}
			if (
				["goal", "own_goal", "penalty_scored", "penalty_missed"].includes(
					e.eventType,
				)
			) {
				for (const actor of [
					!e.playerId ? e.scorerParticipationId : null,
					!e.assistPlayerId ? e.assistParticipationId : null,
				].filter(Boolean)) {
					if (!appeared.has(actor)) {
						onPitch.add(actor);
						appeared.add(actor);
					}
				}
			}
			if (e.eventType === "injury_exit") {
				const actor = e.playerId ?? e.scorerParticipationId;
				onPitch.delete(actor);
				injured.add(actor);
				appeared.add(actor);
				injuryVacancies.add(actor);
			}
			if (["red_card", "double_yellow_card"].includes(e.eventType)) {
				dismissed.add(e.playerId);
				onPitch.delete(e.playerId);
			}
		});
	return {onPitch, appeared, dismissed, injured, injuryVacancies};
};
